/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum StackStateEnumDto {
    PRE_REGISTRATION = 'PreRegistration',
    MEASURED = 'Measured',
    ASSIGNED_TO_SAWMILL = 'AssignedToSawmill',
}